/**
 * @internal
 */
import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Timestamp from '@polestar/component-warehouse-react/components/timestamp/Timestamp';
import Spacer from '@polestar/component-warehouse-react/components/spacer/Spacer';
import Orientations from '@polestar/component-warehouse-react/tokens/orientations/Orientations';
import Spacings, { createCustomSpacing, } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import FontSizes from '@polestar/component-warehouse-react/tokens/font-sizes/FontSizes';
const TimeCode = forwardRef(({ currentTime, duration, ...props }, ref) => {
    return (React.createElement(VideoTimers, { ...props, duration: duration, ref: ref },
        React.createElement(Timestamp, { "data-type": "timestamp", value: currentTime, background: false }),
        !!duration && (React.createElement(React.Fragment, null,
            React.createElement(Spacer, { spacing: createCustomSpacing(2 / 16), orientation: Orientations.horizontal }),
            "/",
            React.createElement(Spacer, { spacing: createCustomSpacing(2 / 16), orientation: Orientations.horizontal }),
            React.createElement(Timestamp, { "data-type": "timestamp", value: duration, background: false })))));
});
TimeCode.displayName = 'TimeCode';
export default TimeCode;
const VideoTimers = styled.div(({ duration }) => css `
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: ${Spacings.xxLarge};
    line-height: ${FontSizes.body};
    pointer-events: none;
    justify-content: center;
    font-size: ${FontSizes.body};
    white-space: nowrap;
    max-width: ${duration >= 3600 ? '140px' : '90px'};
  `);
